/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-floating-promises */
import {
  Avatar,
  Button,
  Col,
  Descriptions,
  Divider,
  Dropdown,
  Input,
  type InputRef,
  List,
  type MenuProps,
  message,
  PageHeader,
  Popover,
  Row,
  Space,
  Typography,
  Comment,
  Form,
  Upload,
  type UploadFile,
  Spin,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toNumber } from "lodash";
import { useAppDispatch, useAppSelector } from "../hooks/hooks";
import {
  fullIssueAsync,
  selectFullIssue,
  selectStatus,
  websocketUpdatesIssue,
} from "../redux/slices/midservice/midserviceSlice";
import { timestampToReadableZone } from "../utils/time";
import { JsonViewer } from "@textea/json-viewer";
import {
  DownOutlined,
  PaperClipOutlined,
  UserAddOutlined,
} from "@ant-design/icons";
import {
  type Attachment,
  IssueStatus,
  type Participant,
} from "../redux/slices/midservice/midserviceTypes";
import { API } from "../api/Api";
import { selectCurrentUser } from "../redux/slices/user/userSlice";
import Link from "antd/lib/typography/Link";
import ProgressMessage from "../components/ProgressMessage";
import useWebSocket from "react-use-websocket";
import { getApiUrlWS } from "../utils/url";
import { StatusIconMap } from "../components/StatusTag";
import { ErrorPage } from "./ErrorPage";

const { Title, Text } = Typography;
const { TextArea } = Input;

const SingleIssuePage: React.FC = () => {
  const params = useParams();
  const issueId: number = toNumber(params.issueId);
  const user = useAppSelector(selectCurrentUser);
  const status = useAppSelector(selectStatus);

  const { sendMessage } = useWebSocket(
    `${getApiUrlWS()}/api/v1/issue/ws/updates?issue_id=${issueId}&user_id=${
      user.id
    }`,
    {
      shouldReconnect: () => true,
      reconnectAttempts: 5,
      reconnectInterval: 3,
      onMessage(event) {
        dispatch(websocketUpdatesIssue(JSON.parse(event.data)));
      },
    },
  );

  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const fullIssue = useAppSelector(selectFullIssue);

  const items: MenuProps["items"] = Object.entries(IssueStatus)
    .filter(([key]) => key !== fullIssue?.singleIssue.status)
    .map(([status, label]) => {
      return {
        key: status,
        label,
        icon: StatusIconMap[status],
      };
    });

  const [implementerString, setImplementerString] = useState<string>("");
  const [observerString, setObserverString] = useState<string>("");
  const [users, setUsers] = useState<Participant[]>([]);
  const inputRefObserver = useRef<InputRef>(null);
  const inputRefImplementer = useRef<InputRef>(null);

  const [submitting, setSubmitting] = useState(false);
  const [comment, setComment] = useState<string>("");

  const [fileList, setFileList] = useState<UploadFile[]>([]);

  useEffect(() => {
    inputRefObserver.current?.focus();
  }, [observerString]);
  useEffect(() => {
    inputRefImplementer.current?.focus();
  }, [implementerString]);

  useEffect(() => {
    dispatch(fullIssueAsync(issueId));
  }, []);

  useEffect(() => {
    async function fetchParticipants(): Promise<void> {
      try {
        const { data } = await API.getParticipantsList();
        setUsers(data);
      } catch (error) {
        console.error("Error get users", error);
      }
    }

    fetchParticipants();
  }, []);

  const handleParticipantClick = async (
    userId: number,
    isAssignee: number,
  ): Promise<void> => {
    try {
      sendMessage(
        JSON.stringify({
          message: {
            issue_id: issueId,
            user_id: userId,
            is_assignee: isAssignee,
          },
          messageType: "ISSUE_PARTICIPANTS",
        }),
      );
    } catch (error) {
      console.error("Set issue assignee error", error);
    }
  };

  const ParticipantsContent = ({
    isAssignee,
    inputRef,
    usersString,
    setUsersString,
  }: {
    isAssignee: number;
    inputRef: any;
    usersString: string;
    setUsersString: any;
  }): JSX.Element => {
    return (
      <div style={{ width: "100%" }}>
        <Input
          ref={inputRef}
          value={usersString}
          onChange={(e) => {
            setUsersString(e.target.value);
          }}
        ></Input>
        {fullIssue?.participants ? (
          <List
            pagination={{ pageSize: 5 }}
            itemLayout="horizontal"
            dataSource={
              usersString
                ? users.filter((u) => {
                    if (
                      fullIssue?.participants.some(
                        (p) => p.id === u.id && p.isAssignee === isAssignee,
                      )
                    ) {
                      return false;
                    }
                    if (u.name === null) {
                      return u.login
                        .toLocaleLowerCase()
                        .includes(usersString.toLocaleLowerCase());
                    }
                    return (
                      u.name
                        .toLocaleLowerCase()
                        .includes(usersString.toLocaleLowerCase()) ||
                      u.login
                        .toLocaleLowerCase()
                        .includes(usersString.toLocaleLowerCase())
                    );
                  })
                : [
                    ...users.filter((u) => {
                      if (
                        fullIssue.participants.some(
                          (p) => p.id === u.id && p.isAssignee === isAssignee,
                        )
                      ) {
                        return false;
                      }
                      return u;
                    }),
                  ]
            }
            size="small"
            renderItem={(u) => (
              <List.Item
                onClick={() => {
                  handleParticipantClick(u.id, isAssignee);
                }}
              >
                <div style={{ width: "100%" }}>
                  <List.Item.Meta
                    avatar={
                      <Avatar
                        size={"small"}
                        src={`https://gamma.heado.ru/go/ava?name=${
                          u.name ?? u.login
                        }`}
                      />
                    }
                    title={
                      <Text type="secondary">
                        {u.id === user.id
                          ? "Вы"
                          : u.name
                          ? `${u.name}\n(${u.login})`
                          : u.login}
                      </Text>
                    }
                  />
                </div>
              </List.Item>
            )}
          ></List>
        ) : null}
      </div>
    );
  };

  const handleMenuClick: MenuProps["onClick"] = (e): void => {
    const newStatus = e.key;
    try {
      sendMessage(
        JSON.stringify({
          message_type: "ISSUE_STATUS",
          message: { status: newStatus, issue_id: issueId, user_id: user.id },
        }),
      );
    } catch (error) {
      console.error("Set issue status error", error);
    }
  };

  const menuProps = {
    items,
    onClick: handleMenuClick,
  };

  const commentSubmit = (): void => {
    if (!comment) return;
    setSubmitting(true);

    createComment()
      .then(() => {
        setComment("");
        setFileList([]);
      })
      .catch((error) => {
        console.error("Create comment error", error);
        message.error("Ошибка при созданние комментария");
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  const createComment = async (): Promise<void> => {
    try {
      const files: File[] = fileList
        .map((file) => file.originFileObj as File)
        .filter((file): file is File => Boolean(file));
      await API.createIssueComment(issueId, comment, files);
    } catch (error) {
      console.error("Create comment error", error);
    }
  };

  const downloadFile = async (e: any, a: Attachment): Promise<void> => {
    e.preventDefault();
    const messageKey = "download";
    message.open({
      key: messageKey,
      content: <ProgressMessage progress={0} type={messageKey} />,
      duration: 0,
      icon: null,
    });

    try {
      const response = await API.getIssueCommentFile(
        issueId,
        a.uri,
        (progress: number) => {
          message.open({
            key: messageKey,
            content: <ProgressMessage progress={progress} type={messageKey} />,
            duration: 0,
            icon: null,
          });
        },
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", a.uri);
      document.body.appendChild(link);
      link.click();
      link.remove();
      message.success({
        key: messageKey,
        content: "Файл успешно загружен",
        duration: 2,
      });
    } catch (error) {
      console.error("Download file error", error);
      message.error({
        key: messageKey,
        content: "Ошибка при скачивании файла",
        duration: 2,
      });
    }
  };

  return (
    <>
      {status === "success" && fullIssue != null ? (
        <>
          <PageHeader
            style={{
              padding: 0,
              marginBottom: "1.25rem",
              borderBottom: "1px solid #d9d9d9",
            }}
            className="site-page-header"
            onBack={() => {
              window.history.back();
            }}
            title={`${fullIssue.singleIssue.sourceType}-${fullIssue.singleIssue.eventId}-${fullIssue.singleIssue.id}`}
          />
          <Row gutter={[48, 40]}>
            <Col span={16}>
              <Text
                style={{ marginBottom: -16 }}
                type="secondary"
              >{`Постановка ${timestampToReadableZone(
                fullIssue.singleIssue.createdAt,
              )}`}</Text>
              <Title
                level={2}
                style={{ marginTop: 0, cursor: "pointer" }}
                onClick={() => {
                  navigate(`/instances/${fullIssue.singleIssue.sourceId}`);
                }}
              >{`${fullIssue.singleIssue.domain} / ${
                fullIssue.singleIssue.title
              } / ${
                fullIssue.singleIssue.name
                  ? fullIssue.singleIssue.name
                  : "Устройство"
              }`}</Title>
              <JsonViewer
                rootName={false}
                value={fullIssue.singleIssue.media}
              />
              <Divider />
              <Title level={3}>Комментарии</Title>
              {fullIssue.comments.length ? (
                <List
                  className="comment-list"
                  itemLayout="horizontal"
                  dataSource={fullIssue.comments}
                  renderItem={(comment) => (
                    <li>
                      <Comment
                        author={comment.name ?? comment.login}
                        avatar={
                          <Avatar
                            src={`https://gamma.heado.ru/go/ava?name=${
                              comment.name ?? comment.login
                            }`}
                          />
                        }
                        content={comment.media.text}
                        datetime={timestampToReadableZone(comment.createdAt)}
                      />
                      {comment.media.attachments?.length ? (
                        <List
                          dataSource={comment.media.attachments}
                          renderItem={(attachment) => (
                            <li>
                              <Link
                                onClick={(e) => {
                                  downloadFile(e, attachment);
                                }}
                              >
                                {attachment.uri}
                              </Link>
                            </li>
                          )}
                        ></List>
                      ) : null}
                    </li>
                  )}
                />
              ) : null}
              <Comment
                avatar={
                  <Avatar
                    src={`https://gamma.heado.ru/go/ava?name=${
                      user.name ?? user.login
                    }`}
                  />
                }
                content={
                  <>
                    <Form.Item>
                      <TextArea
                        rows={4}
                        onChange={(e) => {
                          setComment(e.target.value);
                        }}
                        value={comment}
                      />
                    </Form.Item>
                    <Form.Item>
                      <Row justify="space-between">
                        <Upload
                          multiple={true}
                          onChange={({ fileList }) => {
                            setFileList(fileList);
                          }}
                          fileList={fileList}
                          beforeUpload={() => false}
                        >
                          <Button icon={<PaperClipOutlined />}>
                            Добавить файл
                          </Button>
                        </Upload>
                        <Button
                          htmlType="submit"
                          loading={submitting}
                          onClick={commentSubmit}
                          type="primary"
                        >
                          Добавить комментарий
                        </Button>
                      </Row>
                    </Form.Item>
                  </>
                }
              />
            </Col>
            <Col
              span={8}
              style={{ borderLeft: "1px solid #d9d9d9", height: "100%" }}
            >
              <Descriptions column={1}>
                <Descriptions.Item label="Статус">
                  <Dropdown menu={menuProps}>
                    <Button>
                      <Space>
                        {StatusIconMap[fullIssue.singleIssue.status]}
                        {IssueStatus[fullIssue.singleIssue.status]}
                        <DownOutlined />
                      </Space>
                    </Button>
                  </Dropdown>
                </Descriptions.Item>
                <Descriptions.Item label="Интенсивность">
                  {fullIssue.singleIssue.eventCount}
                </Descriptions.Item>
                <Descriptions.Item label="Срок исполнения">
                  {timestampToReadableZone(fullIssue.singleIssue.dueAt)}
                </Descriptions.Item>
                <Descriptions.Item label="Наблюдатели">
                  {fullIssue.participants.length > 0 ? (
                    <div style={{ width: "100%" }}>
                      <List
                        itemLayout="horizontal"
                        dataSource={fullIssue.participants}
                        size="small"
                        renderItem={(o) => (
                          <List.Item>
                            <List.Item.Meta
                              avatar={
                                <Avatar
                                  size={"small"}
                                  src={`https://gamma.heado.ru/go/ava?name=${
                                    o.name || o.login
                                  }`}
                                />
                              }
                              title={
                                <Text type="secondary">
                                  {o.name || o.login}
                                </Text>
                              }
                            />
                          </List.Item>
                        )}
                        footer={
                          <Popover
                            content={
                              <ParticipantsContent
                                isAssignee={0}
                                inputRef={inputRefObserver}
                                usersString={observerString}
                                setUsersString={setObserverString}
                              />
                            }
                            placement="bottom"
                            trigger="click"
                          >
                            <UserAddOutlined
                              style={{ paddingLeft: "18px", fontSize: "20px" }}
                            />
                          </Popover>
                        }
                      />
                    </div>
                  ) : (
                    <Text type="secondary">Нет наблюдателей</Text>
                  )}
                </Descriptions.Item>
                <Descriptions.Item label="Исполнители">
                  {fullIssue.participants.filter((p) => p.isAssignee === 1)
                    .length > 0 ? (
                    <div style={{ width: "100%" }}>
                      <List
                        itemLayout="horizontal"
                        dataSource={fullIssue.participants.filter(
                          (p) => p.isAssignee === 1,
                        )}
                        size="small"
                        renderItem={(i) => (
                          <List.Item>
                            <List.Item.Meta
                              avatar={
                                <Avatar
                                  size={"small"}
                                  src={`https://gamma.heado.ru/go/ava?name=${
                                    i.name || i.login
                                  }`}
                                />
                              }
                              title={
                                <Text type="secondary">
                                  {i.name || i.login}
                                </Text>
                              }
                            />
                          </List.Item>
                        )}
                        footer={
                          <Popover
                            content={
                              <ParticipantsContent
                                isAssignee={1}
                                inputRef={inputRefImplementer}
                                usersString={implementerString}
                                setUsersString={setImplementerString}
                              />
                            }
                            placement="bottom"
                            trigger="click"
                          >
                            <UserAddOutlined
                              style={{ paddingLeft: "18px", fontSize: "20px" }}
                            />
                          </Popover>
                        }
                      />
                    </div>
                  ) : (
                    <Popover
                      content={
                        <ParticipantsContent
                          isAssignee={1}
                          inputRef={inputRefImplementer}
                          usersString={implementerString}
                          setUsersString={setImplementerString}
                        />
                      }
                      placement="bottom"
                      trigger="click"
                    >
                      <UserAddOutlined style={{ fontSize: "20px" }} />
                    </Popover>
                  )}
                </Descriptions.Item>
              </Descriptions>
            </Col>
          </Row>
        </>
      ) : status === "loading" ? (
        <Spin size="large"></Spin>
      ) : (
        <ErrorPage status="404" description="Проблема не найдена"></ErrorPage>
      )}
    </>
  );
};

export default SingleIssuePage;
